import { AinErrorType, DeliveryIssueTypeInternational } from '../../../../enums';

export interface IDeliverySubtypeInt {
    issueType: DeliveryIssueTypeInternational;
    shipmentNumber?: string;
    incorrectDeliveryInDocumentation?: boolean;
    incorrectDeliveryAddress?: string;
    wrongCarrier?: string;
    ainErrorType?: AinErrorType;
    replacementOrderRequired?: boolean;
    replacementOrderNumber?: string;
}
